/* eslint no-template-curly-in-string: 0 */
import { FLOW_TYPES, PAYMENT_NETWORKS, PAYMENT_STATUSES } from "../../../../utils/enums";

export const mastercard ={
  id: PAYMENT_NETWORKS.MASTERCARD,
  displayName: "Mastercard",
  paywall: {
    tile: {
      displayName: ["Tarjeta de Regalo Mastercard"],
      tagline: [
        {
          type: 'div',
          string: "Tarjeta de débito digital para",
        },
        {
          type: 'div',
          string: 'usar en línea o en tiendas',
        }
      ],
      description: [
        {
          string: 'Efectivo al instante para gastar',
          type: 'div'
        },
        {
          string: "cuando y donde sea",
          type: 'div'
        }
      ],
    }
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.AUTO_LOGIN,
    loading: {
      title: "Preparando su Mastercard™"
    }
  },
  acceptPayment: {
    description: [
      "Ha elegido recibir una tarjeta de regalo Mastercard de ",
      {
        string: "${payment.amount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      " que será enviado por correo electrónico a ",
      {
        string: "${payment.recipientEmail}.",
        props: {
          className: 'payment-recipientEmail'
        }
      },
      "."
    ],
  },
  paymentComplete: {
    initial: {
      title: "¡Pago exitoso!",
      description: [
        "¡Éxito! Por favor, revise su correo electrónico ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          },
        },
        " para obtener más información con respecto a su ",
        {
          string: "Mastercard eGiftCard™",
          props: {
            className: 'payment-paymentNetwork'
          }
        },
        " de ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        ". Debería llegarle pronto e incluirá los detalles para su uso."
      ],
      secondaryText: "Por favor, considere esta tarjeta como si fuese dinero en efectivo y tenga el debido cuidado para evitar la pérdida o robo.",
    },
    revisit: {
      description: [
        "El ",
        {
          string: "${payment.updatedAt}",
          props: {
            className: 'payment-updatedAt',
          },
          transformations: [
            {
              type: "formatDate"
            }
          ],
        },
        ", un correo electrónico fue enviado a ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          },
        },
        " con los detalles relacionados con su ",
        {
          string: "Mastercard eGiftCard™",
          props: {
            className: 'payment-paymentNetwork'
          }
        },
        " de ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        "."
      ],
      secondaryText: "Por favor, considere esta tarjeta como si fuese dinero en efectivo y tenga el debido cuidado para evitar la pérdida o robo.",
    },
  },
  faqs: {
    byPaymentStatus: {
      [PAYMENT_STATUSES.PENDING_ACCEPTANCE]: [
        {
          answer: "La cuenta virtual la emite MetaBank®, miembro de la FDIC, conforme a la licencia de Mastercard International Incorporated. Mastercard es una marca registrada, y el diseño de los círculos es una marca de Mastercard International Incorporated. No hay acceso a efectivo ni pagos recurrentes. Se puede usar en línea, por teléfono/correo o en tiendas que aceptan cartera electrónica que a su vez acepte la tarjeta de débito Mastercard en los EE. UU. Cuenta válida por hasta siete años; los fondos no caducan y pueden estar disponibles después de la fecha de caducidad de la tarjeta, podrían aplicarse cargos.",
          question: "Acerca de la tarjeta de regalo Mastercard®"
        }
      ],
      [PAYMENT_STATUSES.COMPLETE]: [
        {
          answer: "La cuenta virtual la emite MetaBank®, miembro de la FDIC, conforme a la licencia de Mastercard International Incorporated. Mastercard es una marca registrada, y el diseño de los círculos es una marca de Mastercard International Incorporated. No hay acceso a efectivo ni pagos recurrentes. Se puede usar en línea, por teléfono/correo o en tiendas que aceptan cartera electrónica que a su vez acepte la tarjeta de débito Mastercard en los EE. UU. Cuenta válida por hasta siete años; los fondos no caducan y pueden estar disponibles después de la fecha de caducidad de la tarjeta, podrían aplicarse cargos.",
          question: "Acerca de la tarjeta de regalo Mastercard®"
        }
      ]
    }
  },
};

export default mastercard;
